// src/components/Contract/PartiesContactInfo.tsx
import React from 'react';

interface Props {
  buyerEmail?: string;
  buyerPhone?: string;
  buyer2Email?: string;
  buyer2Phone?: string;
  sellerEmail?: string;
  sellerPhone?: string;
  seller2Email?: string;
  seller2Phone?: string;
  buyerAddress?: {
    street?: string;
    city?: string;
    state?: string;
    zip?: string;
  };
  sellerAddress?: {
    street?: string;
    city?: string;
    state?: string;
    zip?: string;
  };
}

const PartiesContactInfo: React.FC<Props> = ({
  buyerEmail,
  buyerPhone,
  buyer2Email,
  buyer2Phone,
  sellerEmail,
  sellerPhone,
  buyerAddress,
  sellerAddress,
  seller2Email,
  seller2Phone,
}) => (
  <div className="mb-6">
    <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
      PARTIES CONTACT INFORMATION
    </h2>
    <div className="space-y-2">
      <p>
        {' '}
        <strong>Buyer Contact Information:</strong>
      </p>
      <div className="ml-6 space-y-1">
        <p>
          • Email Address:{' '}
          <span className="font-semibold">{buyerEmail || 'N/A'}</span>
        </p>
        {buyer2Email && (
          <p>
            • Email Address:{' '}
            <span className="font-semibold">{buyer2Email || 'N/A'}</span>
          </p>
        )}

        <p>
          • Phone Number:{' '}
          <span className="font-semibold">{buyerPhone || 'N/A'}</span>
        </p>
        {buyer2Phone && (
          <p>
            • Phone Number:{' '}
            <span className="font-semibold">{buyer2Phone || 'N/A'}</span>
          </p>
        )}
        <p>
          • Mailing Address:{' '}
          <span className="font-semibold">
            {buyerAddress?.street &&
            buyerAddress?.city &&
            buyerAddress?.state &&
            buyerAddress?.zip
              ? `${buyerAddress.street}, ${buyerAddress.city}, ${buyerAddress.state} ${buyerAddress.zip}`
              : 'N/A'}
          </span>
        </p>
      </div>

      <p>
        {' '}
        <strong>Seller Contact Information:</strong>
      </p>
      <div className="ml-6 space-y-1">
        <p>
          • Email Address:{' '}
          <span className="font-semibold">{sellerEmail || 'N/A'}</span>
        </p>
        {seller2Email && (
          <p>
            • Email Address:{' '}
            <span className="font-semibold">{seller2Email || 'N/A'}</span>
          </p>
        )}
        <p>
          • Phone Number:{' '}
          <span className="font-semibold">{sellerPhone || 'N/A'}</span>
        </p>
        {seller2Phone && (
          <p>
            • Phone Number:{' '}
            <span className="font-semibold">{seller2Phone || 'N/A'}</span>
          </p>
        )}
        <p>
          • Mailing Address:{' '}
          <span className="font-semibold">
            {sellerAddress?.street &&
            sellerAddress?.city &&
            sellerAddress?.state &&
            sellerAddress?.zip
              ? `${sellerAddress.street}, ${sellerAddress.city}, ${sellerAddress.state} ${sellerAddress.zip}`
              : 'N/A'}
          </span>
        </p>
      </div>
    </div>
  </div>
);

export default PartiesContactInfo;
